import type { Timestamp } from "firebase/firestore";
import type BaseModuleModel from "../modules/core/BaseModuleModel";
import type BusinessModuleModel from "./modules/BusinessModuleModel";
import type { BusinessScheduleItemData } from "./schedule/BusinessScheduleItem";

export type Event = BusinessScheduleItemData & {
  type: "item";
  date: string;
};

export type EventModule = {
  uid: string;
  date: string;
  title: string;
  description?: string;
  // biome-ignore lint/suspicious/noExplicitAny: We don't care
  module: BusinessModuleModel<any, any> & {
    isCompletedByUser: boolean;
    calculatedDate: Timestamp;
  };
  type: "module";
};

export type EventTeamModule = {
  uid: string;
  date: string;
  title: string;
  description?: string;
  // biome-ignore lint/suspicious/noExplicitAny: We don't care
  module: BaseModuleModel<any, any> & {
    isCompletedByUser: boolean;
    toggleCompletedByUser: (userId: string) => void;
    data: { dateDue: Timestamp };
  };
  type: "team-module";
};

export type EventToday = {
  date: string;
  title: string;
  type: "today";
};

export type EventHeader = {
  title: string;
  type: "header";
};

export function isEvent(
  item: Event | EventHeader | EventToday | EventModule | EventTeamModule,
): item is Event {
  return item.type === "item";
}

export function isEventModule(
  item: Event | EventHeader | EventToday | EventModule | EventTeamModule,
): item is EventModule {
  return item.type === "module";
}

export function isEventTeamModule(
  item: Event | EventHeader | EventToday | EventModule | EventTeamModule,
): item is EventTeamModule {
  return item.type === "team-module";
}

export function isEventToday(
  item: Event | EventHeader | EventToday | EventModule | EventTeamModule,
): item is EventToday {
  return item.type === "today";
}

export function getEventStartTime(item: Event) {
  return item.schedule?.[0]?.startTime;
}

export function getEventEndTime(item: Event) {
  const lastItem = item.schedule?.[item.schedule.length - 1];
  const startTime = getEventStartTime(item);
  const endTime = lastItem?.endTime || lastItem?.startTime;

  if (startTime !== endTime) {
    return endTime;
  }
}
